import moment from "moment";

export default {
  methods: {
    groupOrdersByTime(orders) {
      const key = "opened_on";
      const result = {};
      const months = this.months();
      months.forEach(month => {
        result[month] = [];
      });

      orders.forEach(order => {
        let timeKey = `${this.monthFormat(order[key])}`;
        if (!result[timeKey]) {
          result[timeKey] = [];
        }
        result[timeKey].push(order);
      });

      return result;
    },
    groupOrdersByDay(orders) {
      const key = "opened_on";
      const result = {};
      const days = this.days();
      days.forEach(day => {
        result[day] = [];
      });

      orders.forEach(order => {
        let timeKey = `${this.dayFormat(order[key])}`;
        if (!result[timeKey]) {
          result[timeKey] = [];
        }
        result[timeKey].push(order);
      });

      return result;
    },
    groupDailyOrdersByTime(orders) {
      const key = "opened_on";
      const result = {};

      // orders by ascending date time
      orders = orders.sort(this.compareByTime);
      orders.forEach(order => {
        let timeKey = `${this.dayFormatChart(order[key])}`;
        if (!result[timeKey]) {
          result[timeKey] = [];
        }
        result[timeKey].push(order);
      });

      return result;
    },
    monthFormat(time) {
      if (!time) {
        return "";
      }
      let myDate = time.seconds * 1000; // Unix ms timestamp
      return this.months()[moment(myDate).month()];
    },
    dayFormat(time) {
      if (!time) {
        return "";
      }
      let myDate = time.seconds * 1000; // Unix ms timestamp
      return this.days()[moment(myDate).day()];
    },
    months() {
      moment.locale("es");
      return moment.monthsShort();
    },
    days() {
      moment.locale("es");
      return moment.weekdaysShort(true);
    },
    dayFormatChart(time) {
      if (!time) {
        return "";
      }
      let myDate = time.seconds * 1000; // Unix ms timestamp
      return moment(myDate).format("DD/MM");
    },
    addNumberFormat(quantity) {
      return new Intl.NumberFormat("es-ES", {
        maximumFractionDigits: 2
      }).format(quantity);
    },
    compareByTime(a, b) {
      if (a.opened_on.toMillis() < b.opened_on.toMillis()) {
        return -1;
      }
      if (a.opened_on.toMillis() > b.opened_on.toMillis()) {
        return 1;
      }
      return 0;
    },
    isFoodType(productTypeSelected) {
      return productTypeSelected === this.$store.state.productTypeIds.food;
    },
    isDrinkType(productTypeSelected) {
      return productTypeSelected === this.$store.state.productTypeIds.drinks;
    },
    isDessertType(productTypeSelected) {
      return productTypeSelected === this.$store.state.productTypeIds.dessert;
    },
    getOrderType(selectedType) {
      if (selectedType === this.$store.state.productTypeIds.drinks) {
        return "drinks";
      }
      if (selectedType === this.$store.state.productTypeIds.food) {
        return "food";
      }
      return "dessert";
    }
  }
};
